"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  result["default"] = mod;
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importStar(require("react"));
var field_validation_errors_1 = require("./field-validation-errors");
var label_1 = require("./label");
var ValidationDataModels_1 = require("../../ValidationDataModels");
var FileUpload = /** @class */function (_super) {
  __extends(FileUpload, _super);
  function FileUpload() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.fileInputRef = react_1.createRef();
    _this.SIZE_UNITS = {
      '1': 'Bytes',
      '1024': 'KB',
      '1048576': 'MB',
      '1073741824': 'GB'
    };
    _this.onChangeField = function (files, field, cb) {
      var fileSizeValidator = _this.getEnabledValidation(ValidationDataModels_1.ValidationDataModels.FileSizeValidator);
      var fileCountValidator = _this.getEnabledValidation(ValidationDataModels_1.ValidationDataModels.FileCountValidator);
      var fileTypeValidator = _this.getEnabledValidation(ValidationDataModels_1.ValidationDataModels.FileTypeValidator);
      var list = [];
      var errorMessages = [];
      var valid = true;
      if (files) {
        Array(files.length).fill(null).forEach(function (_, idx) {
          var fileSize = files[idx].size / field.model.fileSizeUnit;
          if (valid && fileSizeValidator && fileSize > field.model.maxFileSize) {
            var msg = fileSizeValidator.message.replace('{0}', field.model.maxFileSize.toString()).replace('{1}', _this.getFileSizeUnitName(field.model.fileSizeUnit));
            errorMessages.push(msg);
            valid = false;
          }
          list.push(files[idx]);
        });
      }
      if (fileTypeValidator) {
        list.some(function (file) {
          var ext = file.name.split('.').pop() || '';
          if (field.model.allowedContentTypes.indexOf(ext) !== -1) {
            return false;
          }
          var msg = fileTypeValidator.message.replace('{0}', field.model.allowedContentTypes);
          errorMessages.push(msg);
          return true;
        });
      }
      if (fileCountValidator && list.length > field.model.maxFileCount) {
        var msg = fileCountValidator.message.replace('{0}', field.model.maxFileCount.toString()).replace('{1}', field.model.title);
        errorMessages.push(msg);
        valid = false;
      }
      if (field.model.required && !list.length) {
        valid = false;
        errorMessages.push(field.model.title + " is required");
      }
      cb(field.valueField.name, list, valid, errorMessages);
    };
    return _this;
  }
  FileUpload.prototype.componentDidUpdate = function (prevProps) {
    if (prevProps.value && !this.props.value && this.fileInputRef.current) {
      this.fileInputRef.current.value = '';
    }
  };
  FileUpload.prototype.getEnabledValidation = function (itemId) {
    return this.props.field.model.validationDataModels.find(function (validation) {
      return validation.itemId === itemId;
    });
  };
  FileUpload.prototype.getFileSizeUnitName = function (value) {
    return this.SIZE_UNITS[value];
  };
  FileUpload.prototype.render = function () {
    var _this = this;
    var _a = this.props,
      field = _a.field,
      value = _a.value,
      onChange = _a.onChange,
      errors = _a.errors,
      tracker = _a.tracker;
    var fileTypeValidator = this.getEnabledValidation(ValidationDataModels_1.ValidationDataModels.FileTypeValidator);
    return react_1.default.createElement(react_1.Fragment, null, react_1.default.createElement(label_1.Label, __assign({}, this.props)), react_1.default.createElement("input", {
      ref: this.fileInputRef,
      type: "file",
      accept: fileTypeValidator ? field.model.allowedContentTypes : undefined,
      multiple: field.model.isMultiple,
      className: field.model.cssClass,
      id: field.valueField.id,
      name: field.valueField.name,
      onChange: function (e) {
        return _this.onChangeField(e.target.files, field, onChange);
      },
      onFocus: function () {
        return tracker.onFocusField(field, value);
      },
      onBlur: function () {
        return tracker.onBlurField(field, value, errors);
      }
    }), react_1.default.createElement(field_validation_errors_1.FieldValidationErrors, __assign({}, this.props)));
  };
  return FileUpload;
}(react_1.Component);
exports.default = FileUpload;